import React from 'react'
import { useMemo, useMedia } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'

import Notification from './Notification/Notification'

import s from './Notifications.scss'


type NotificationsProps = {
  compensation?: Notifications.Item['compensation']
}


// TODO for @akopylov:
// move this module to local_modules
// remove redux and use logic style from new modals
// add animation with scss
const Notifications: React.FunctionComponent<NotificationsProps> = ({ compensation }) => {
  const { items } = useConnect<{ items: Omit<Notifications.Items, 'position'> }>({
    items: 'models.notifications.items',
  })

  const { isMobile } = useMedia()

  const styles = useMemo(() => (
    isMobile ? { bottom: compensation } : { top: compensation }
  ), [ isMobile, compensation ])

  return Boolean(items.length) && (
    <div className={s.notifications} style={styles}>
      {
        items.map(({ id, text, title, svgName }, index) => (
          <Notification
            key={id}
            id={id}
            text={text}
            title={title}
            svgName={svgName}
            position={index + 1}
            compensation={compensation}
          />
        ))
      }
    </div>
  )
}


export default React.memo(Notifications)
